const messages = {
  validation: {
    maxEntries: {
      id: 'admin/promotions.form.utils.maximum-amount-of-items',
    },
  },
}

export default messages
